// extracted by mini-css-extract-plugin
export default {"patientPhotos":"patientPhotos___I8UTS","patientPhotos_photos":"patientPhotos_photos___iEYSv"};